.vs-submarquee-video-transition {
  overflow: hidden;

  & img {
    transition: transform 0.35s ease-in-out;
  }

  &:hover {
    & img {
      transform: scale(1.05);
      cursor: pointer;
    }
  }

  // START GENAI@GHCOPILOT
  &:hover {
    & button {
      opacity: 0.9;

      &:before {
        opacity: 0.9;
      }
    }
  }

  & button:focus {
    opacity: 0.9;
  }
  // END GENAI@GHCOPILOT
}
